import { List } from "./List";
import { GridList } from "./List";
import styles from "./styles/StyledWith.module.css";
import { useTranslation } from "next-i18next";

export const StyledWith = ({ customTitle, products, isGrid }) => {
  const { t } = useTranslation("style");
  return (
    <div className={styles.container}>
      <h4 className={styles.title}>{customTitle ? `${customTitle}:` : t("style-with")}:</h4>
      {isGrid ? <GridList products={products} /> : <List products={products} />}
    </div>
  );
};
